import { render, staticRenderFns } from "./HomeProducts.vue?vue&type=template&id=10e01d7e&scoped=true&"
import script from "./HomeProducts.vue?vue&type=script&lang=js&"
export * from "./HomeProducts.vue?vue&type=script&lang=js&"
import style0 from "./HomeProducts.vue?vue&type=style&index=0&id=10e01d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e01d7e",
  null
  
)

export default component.exports